import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import ProductDetail     from "./pages/ProductDetail";
import { CartProvider }  from "./context/CartContext";
import Checkout          from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import OrderDetail       from "./pages/Orderdetails";
import Settings          from "./pages/Settings";
import Contact from "./pages/Contact";
import Tutorials from "./pages/Tutorials";
// import Cosmetics from "./pages/Cosmetics";
import Returns from "./pages/Returns";
import PaymentReturn from "./pages/PaymentReturn";
import { stripePromise } from "./pages/Checkout";
import { Elements } from '@stripe/react-stripe-js';
import ShippingPolicy from "./pages/ShippingPolicy.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsConditions from "./pages/TermsConditions.jsx";
import ScrollToTop from "./components/ScrollToTop";


// Admin
import AdminLogin        from "./pages/admin/AdminLogin";
import AdminLayout       from "./pages/admin/AdminLayout";
import { AdminProvider } from "./context/AdminContext";

import {
  ToastProvider,
  AuthProvider,
  NavbarGlobalStyles,
  Navbar,
  CartDrawer,
} from "./components/Navbar";

import Footer from "./components/Footer";
import Home   from "./pages/Home";
import Shop   from "./pages/Shop";

// ── Admin Route Guard ─────────────────────────────────────────
function AdminRoute({ children }) {
  const token = localStorage.getItem("adminToken");
  const user  = JSON.parse(localStorage.getItem("adminUser") || "{}");
  if (!token || !["admin", "store_manager"].includes(user.role)) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function ActiveNavbar({ onCartOpen }) {
  const location = useLocation();
  const labelMap = {
  "/":          "Home",
  "/shop":      "Shop",
  "/jewelry":   "Jewelry",
  // "/cosmetics": "Cosmetics",
  "/tutorials": "Tutorials",
  "/contact":   "Contact",
};
  return <Navbar onCartOpen={onCartOpen} activeLink={labelMap[location.pathname] ?? ""} />;
}

function AppShell() {
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    const handler = () => setCartOpen(true);
    window.addEventListener("sf:open-cart", handler);
    return () => window.removeEventListener("sf:open-cart", handler);
  }, []);

  return (
    <>
      <NavbarGlobalStyles />
      <ActiveNavbar onCartOpen={() => setCartOpen(true)} />
      <Routes>
        <Route path="/"                       element={<Home />} />
        <Route path="/shop"                   element={<Shop />} />
        <Route path="/jewelry"                element={<div className="pt-20 p-8">Jewelry Page</div>} />
        <Route path="/tutorials" element={<Tutorials />} />
        {/* <Route path="/cosmetics" element={<Cosmetics />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:id"            element={<ProductDetail />} />
        <Route path="/settings"               element={<Settings />} />
        <Route path="/checkout"               element={<Checkout />} />
        <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
        <Route path="/orders/:id"             element={<OrderDetail />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/payment-return" element={<Elements stripe={stripePromise}><PaymentReturn /></Elements>} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
      </Routes>
      <Footer />
      <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
    </>
  );
}

// ── Admin wrapper (provider + routes in one place) ────────────
function AdminApp() {
  return (
    <AdminProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="*" element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        } />
      </Routes>
    </AdminProvider>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <AuthProvider>
          <CartProvider>
            <Routes>
              {/* ── Admin Routes (no Navbar/Footer) ── */}
              <Route path="/admin/*" element={<AdminApp />} />

              {/* ── Store Routes (with Navbar/Footer) ── */}
              <Route path="/*" element={<AppShell />} />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}